// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiObtainPreDetermination {
    static getAttributeTypeMap() {
        return MedicalBiObtainPreDetermination.attributeTypeMap;
    }
}
MedicalBiObtainPreDetermination.discriminator = undefined;
MedicalBiObtainPreDetermination.additionalProperties = false;
MedicalBiObtainPreDetermination.attributeTypeMap = [
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "org",
        "baseName": "org",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "website",
        "baseName": "website",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiObtainPreDetermination.js.map